<template>
     <v-row>
    <v-col>
  <v-container fluid>
    <v-row>
      <v-col class="d-flex flex-row align-center">
        <v-btn text @click="()=>{this.$router.go(-1)}"><v-icon dark>mdi-arrow-left</v-icon></v-btn>
        <h1>{{plural}}</h1>
        <v-btn class="ml-2" small fab color="info" @click="newForm"><v-icon>mdi-plus</v-icon></v-btn>
        <v-progress-circular
            indeterminate
            color="green"
            v-if="dataLoader"
            style="margin-left: 10px;"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <span class="d-flex flex-row">
          <h3 v-if="isCreate">Create {{singular}}</h3>
          <h3 v-else>Edit ID:{{form.id}} | {{form.name}}</h3>
        </span>
        <span v-if="!isCreate" class="d-flex flex-row mb-2">
          <v-btn v-if="!isEditable" @click="isEditable=!isEditable">Edit</v-btn>
          <v-btn v-else @click="cancelForm">Cancel</v-btn>
          <v-btn class="ml-2" v-if="isEditable" @click="deleteData" color="error">Delete</v-btn>
        </span>
        <v-form :disabled="!isEditable && !isCreate" v-model="validForm">
          <span class="d-flex flex-column">
            <v-select outlined label="Branch" :items="branches" item-text="name" item-value="id" v-model="form.branchId"/>
            <v-text-field :rules="requiredRules" outlined label="Name" v-model="form.name"/>
            <v-select :rules="requiredRules" outlined label="Currency" :items="currencies" item-text="code" item-value="id" v-model="form.currencyId"/>
            <v-text-field aria-autocomplete="none" outlined label="Description" v-model="form.description"/>
            <v-textarea outlined label="Metadata" v-model="form.metadata"/>
          </span>
        </v-form>
        <span v-if="isEditable && !isCreate" class="d-flex flex-row">
          <v-btn :disabled="!validForm" class="ml-1" color="success" @click="updateData" :loading="formLoader">Update</v-btn>
        </span>
        <span v-if="isCreate" class="d-flex flex-row">
          <v-btn :disabled="!validForm" class="ml-1" color="success" @click="createData" :loading="formLoader">Save</v-btn>
        </span>
      </v-col>
      <v-col cols="12" md="8">
        <v-data-table mobile-breakpoint="0"
            :items="data"
            :headers="headers"
            :items-per-page="-1"
            @click:row="rowClick"
            :loading="dataLoader"
        >
          <template v-slot:item.branchId="{ item }">
            <span>{{ lookupBranch(item.branchId)||'Unknown' }}</span>
          </template>
          <template v-slot:item.currencyId="{ item }">
            <span>{{ lookupCurrency(item.currencyId) }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
    </v-col>
   </v-row>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from "axios";

export default {
  name: 'Home',
  data () {
    return {
      dataLoader: false,
      formLoader: false,

      isEditable: false,
      isCreate: true,

      singular: "Register",
      singularLower: "register",
      plural: "Registers",
      pluralLower: "registers",

      requiredRules: [
        v => !!v || 'Field is required.'
      ],

      branches: [],
      currencies: [],

      data: [],
      form: {},
      validForm: false,

      headers: [
        { text: 'Branch', align: 'start', value: 'branchId' },
        { text: 'Name', value: 'name' },
        { text: 'Currency', value: 'currencyId' },
        { text: 'Description', value: 'description' }
      ]
    }
  },
  computed: {
    ...mapGetters(['getEndpoint', 'lookupBranch', 'getBranches'])
  },
  async mounted(){
    try {
      this.dataLoader = true;

      this.branches = this.getBranches;

      let res = await axios.get(`${this.getEndpoint}/api/currencies/lite`)
      this.currencies = res.data.data

      await this.fetchData();

    } finally {
      this.dataLoader = false;
    }
  },
  methods: {
    lookupCurrency(id){
      return this.currencies.find(x => x.id===id)?.code||'Unknown';
    },
    newForm(){
      this.form = {
        branchId: null,
        name: '',
        currencyId: null,
        description: '',
        metadata: ''
      }
      this.isEditable = true;
      this.isCreate = true;
    },
    rowClick(row){
      if(this.form.metadata){
        this.form.metadata = JSON.parse(this.form.metadata)
      }

      this.form = row;

      this.form.metadata = JSON.stringify(this.form.metadata)

      this.isEditable = false;
      this.isCreate = false;
    },
    async cancelForm(){
      try{
        this.formLoader = true;

        await this.fetchData();

        this.form = this.data.find(x=>x.id===this.form.id);

        //custom form data changes here
        this.form.metadata = JSON.stringify(this.form.metadata)

        this.isEditable = false;
      }
      finally
      {
        this.formLoader = false;
      }
    },
    async fetchData(){
      try{
        this.dataLoader = true;

        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}`)
        this.data = res.data.data
      }
      finally {
        this.dataLoader = false;
      }
    },
    async createData(){
      try{
        this.formLoader = true;

        //custom form data changes here
        this.form.metadata = JSON.parse(this.form.metadata)

        await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.form)
        this.$snack(`${this.singular} created!`, "success");

        await this.fetchData();
      }
      finally {
        this.formLoader = false;
      }
    },
    async updateData(){
      try{
        this.formLoader = true;

        //custom form data changes here
        this.form.metadata = JSON.parse(this.form.metadata)

        await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.form.id}`, this.form)

        //custom form data changes here
        this.form.metadata = JSON.stringify(this.form.metadata)

        this.$snack(`${this.singular} updated!`, "success");
      }
      finally {
        this.formLoader = false;
      }
    },
    async deleteData(){
      try{
        this.formLoader = true;

        await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.form.id}`)
        this.$snack(`${this.singular} deleted!`, "success");

        await this.fetchData();

        this.newForm();
      }
      finally {
        this.formLoader = false;
      }
    },
    formatDate(d, type="short"){
      if(!d) return "None";
      if(type=="short")
        return (new Date(d)).toLocaleDateString('en-GB')
      if(type=="long")
        return (new Date(d)).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
    }
  }
}
</script>
